import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loader = () => (
  <div className="container loader flex center">
    <CircularProgress className="icon" color="primary" size={30} />
    <span>Optimizing routes...</span>
  </div>
);

export default Loader;
